import { render, staticRenderFns } from "./PFormSelectMulti.vue?vue&type=template&id=0db3200a&scoped=true&"
import script from "./PFormSelectMulti.vue?vue&type=script&lang=ts&"
export * from "./PFormSelectMulti.vue?vue&type=script&lang=ts&"
import style0 from "./PFormSelectMulti.vue?vue&type=style&index=0&id=0db3200a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3200a",
  null
  
)

export default component.exports